export default __webpack_public_path__ + "static/media/gallery_02.2d6f0760.jpg";